// Nav type
export type navLinkType = {
  label: string;
  url: string;
};

// Nav
const navLinks = [
  {
    label: 'Services',
    url: '#services',
  },
  {
    label: 'Projects',
    url: '#works',
  },
  {
    label: 'About',
    url: '#about-me-section',
  },
  {
    label: 'Experience',
    url: '#experience-section',
  },
  {
    label: 'Contact',
    url: '#contact-section',
  },
];
const navbarLinks = [
  {
    label: 'Home',
    url: '#app',
  },
  ...navLinks,
];

const socialLinks = [
  {
    label: 'GitHub',
    url: 'https://github.com/UlasRenasOrdu',
  },
  {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/in/ulas-renas-ordu/',
  },
  {
    label: 'YouTube',
    url: 'https://www.youtube.com/@nobetcimuhendis',
  },
  {
    label: 'X',
    url: 'https://x.com/NobetciMuhendis',
  },
  {
    label: 'Medium',
    url: 'https://medium.com/@ulasrenas',
  },
];

const heroText =
  "I'm Ulaş, a Software Developer with 5 years of experience spanning full-stack web development (.NET, React) and cross-platform mobile development (Flutter, React Native/Expo).";

const locationPlace = `38°25'N 27°09'E`;
const locationCountry = 'Turkey, İzmir';

export {
  socialLinks,
  heroText,
  locationPlace,
  locationCountry,
  navLinks,
  navbarLinks,
};
